import React from "react";

const ICONS = [
  {
    title: "Fall asleep faster",
    sub: "−18 minutes on average",
    svg: (
      <svg viewBox="0 0 64 64" className="w-12 h-12">
        <circle cx="32" cy="32" r="22" fill="none" stroke="#0e0e10" strokeWidth="1.6" />
        <path d="M32 18 V32 L42 38" stroke="#0e0e10" strokeWidth="2" fill="none" strokeLinecap="round" />
        <path d="M16 18 L8 14 M48 18 L56 14" stroke="#0e0e10" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Stay asleep longer",
    sub: "+47% deep REM cycles",
    svg: (
      <svg viewBox="0 0 64 64" className="w-12 h-12">
        <path d="M44 14 a 22 22 0 1 0 12 36 a 18 18 0 0 1 -12 -36 Z" fill="none" stroke="#0e0e10" strokeWidth="1.6" strokeLinejoin="round" />
        <text x="20" y="36" fontSize="10" fontWeight="700" fill="#0e0e10">Z</text>
        <text x="26" y="44" fontSize="8" fontWeight="700" fill="#0e0e10">z</text>
      </svg>
    ),
  },
  {
    title: "Stop neck & back pain",
    sub: "97% report relief in 14 nights",
    svg: (
      <svg viewBox="0 0 64 64" className="w-12 h-12">
        <circle cx="32" cy="18" r="7" fill="none" stroke="#0e0e10" strokeWidth="1.6" />
        <path d="M32 25 V46" stroke="#0e0e10" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M22 30 H42" stroke="#0e0e10" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M22 38 H42" stroke="#0e0e10" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="46" cy="22" r="4" fill="#d8f06b" stroke="#0e0e10" strokeWidth="1.4" />
        <text x="46" y="25" fontSize="6" fontWeight="900" fill="#0e0e10" textAnchor="middle">✓</text>
      </svg>
    ),
  },
  {
    title: "Wake up happier",
    sub: "Energy score +52%",
    svg: (
      <svg viewBox="0 0 64 64" className="w-12 h-12">
        <circle cx="32" cy="32" r="14" fill="none" stroke="#0e0e10" strokeWidth="1.6" />
        <circle cx="27" cy="30" r="1.5" fill="#0e0e10" />
        <circle cx="37" cy="30" r="1.5" fill="#0e0e10" />
        <path d="M26 36 Q32 42 38 36" fill="none" stroke="#0e0e10" strokeWidth="1.8" strokeLinecap="round" />
        {[0, 45, 90, 135, 180, 225, 270, 315].map((a, i) => (
          <line
            key={i}
            x1={32 + Math.cos((a * Math.PI) / 180) * 20}
            y1={32 + Math.sin((a * Math.PI) / 180) * 20}
            x2={32 + Math.cos((a * Math.PI) / 180) * 26}
            y2={32 + Math.sin((a * Math.PI) / 180) * 26}
            stroke="#b8952a"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        ))}
      </svg>
    ),
  },
];

export default function SleepBenefits() {
  return (
    <section className="aurora-wrap py-16 md:py-24">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto">
          <span className="section-pill">✨ Why it works</span>
          <h2 className="mt-5 text-[32px] sm:text-[42px] md:text-[52px] leading-[1.05] font-black tracking-[-0.02em] text-[#0e0e10]">
            Four changes you&apos;ll feel
            <br />
            <span className="text-[#8a8a8a]">from night one.</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-5xl mx-auto">
          {ICONS.map((b) => (
            <div
              key={b.title}
              className="bg-white rounded-3xl border border-black/5 p-6 md:p-7 text-center hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto rounded-2xl bg-[#faf8f4] flex items-center justify-center mb-4">
                {b.svg}
              </div>
              <h3 className="font-extrabold text-[15px] md:text-[16px] text-[#0e0e10] leading-tight">
                {b.title}
              </h3>
              <p className="mt-1.5 text-[12px] text-[#6b6b72]">{b.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
